import React from "react";

const NoRecord = () => {
  return (
    <div>
      <p className="h1">No users found</p>
    </div>
  );
};

export default NoRecord;
